export default __webpack_public_path__ + "static/media/siam4.f05be573.png";